import React from 'react';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Modal from 'react-bootstrap/Modal';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

const columns = [
    { title: 'From', field: 'From' },
    { title: 'To', field: 'To' },
    { title: 'UserType', field: 'UserType' },
    { title: 'On Date', field: 'Date' ,render: (item) => getFormattedDateTime(item.Date)},
    { title: 'Mapped By', field: 'UpdatedBy' }
];

class HistoryMapping extends React.Component {
    _isMounted = false;
    state = {
        showSpinner: true,
        alert: 0,
        alertMessage: '',
        flag: true,
        data: []
    };

    componentWillUnmount() {
        this._isMounted = false;
    }
    async componentDidMount() {
        
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        if (this._isMounted) {
            this.setState({ flag: true });
        }

        let data = {
            StoreTag: this.props.selectedRow.StoreTag
        };
        
        await RestServices.getStoreTagMappingHistory(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData) {
                    if (responseData.error) {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: responseData.error
                            });
                        }
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                data: responseData,
                                flag: false,
                                alert: 0,
                                showTable: true
                            });
                        }
                    }
                } else {
                    if (this._isMounted) {
                        this.setState({
                            data: [],
                            flag: false,
                            alert: 0,
                            showTable: true
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    render() {
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                <MaterialTable
                    components={{
                        Pagination: PatchedPagination
                    }}
                    title="Mapping History"
                    columns={columns}
                    data={this.state.data}
                    options={{
                        actionsColumnIndex: -1,
                        selection: false,
                        exportButton: true,
                        showFirstLastPageButtons: true,
                        pageSize: 5,
                        pageSizeOptions: [5, 15, 25, 50, 100]
                    }}
                />
            </Container>
        );
    }
}

export default HistoryMapping;
